import { render } from "./CheckBoxField.vue?vue&type=template&id=149846d7"
import script from "./CheckBoxField.vue?vue&type=script&lang=js"
export * from "./CheckBoxField.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__